export default __webpack_public_path__ + "static/TTCommons-Regular-6e64b30e835e5872e2249aab543fd410.woff";